/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialCompanyResponse } from '../../models/editorial-company-response';

export interface GetEditorialCompany$Params {
  id: number;
}

export function getEditorialCompany(http: HttpClient, rootUrl: string, params: GetEditorialCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialCompanyResponse>> {
  const rb = new RequestBuilder(rootUrl, getEditorialCompany.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditorialCompanyResponse>;
    })
  );
}

getEditorialCompany.PATH = '/api/editorial/companies/{id}';
